import classNames from 'classnames'
import React from 'react'

interface ArrowIconProps {
	direction?: 'left' | 'right'
}

const ArrowIcon: React.FC<ArrowIconProps> = ({ direction = 'left' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="22"
		height="10"
		fill="none"
		viewBox="0 0 22 10"
		className={classNames({
			'transform rotate-180': direction === 'right',
		})}
	>
		<path
			fill="#FFF"
			stroke="#FFF"
			strokeWidth="0.6"
			d="M4.432 1.12a.402.402 0 01.573 0 .405.405 0 010 .568L2.098 4.595h18.785a.4.4 0 01.402.402.404.404 0 01-.402.407H2.098l2.907 2.902a.412.412 0 010 .574.402.402 0 01-.573 0L.836 5.284a.395.395 0 010-.568L4.432 1.12z"
		/>
	</svg>
)

export default ArrowIcon
